import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import i18n, { i18nReady } from './i18n';
import { I18nextProvider } from 'react-i18next';
import { activateDeferredVideos } from './utils/heroVideo';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Çeviriler inmeden çizersek ekranda bir an çeviri anahtarları görünür; bekle.
i18nReady.finally(() => {
  root.render(
    <React.StrictMode>
      <I18nextProvider i18n={i18n}>
        <App />
      </I18nextProvider>
    </React.StrictMode>
  );
});

// Giriş videoları sayfa yüklendikten sonra başlar
activateDeferredVideos();
